import React from 'react'
import styled from 'styled-components'
import { useLocation } from '@reach/router'
import { useTranslation } from 'react-i18next'
import ContactForm from './ContactForm'
const FooterWrapper = styled.div``

const Headline = styled.h2`
  font-family: 'TT Norms Pro';
  font-style: normal;
  font-size: 42px;
  line-height: 54px;
  color: ${(props) => (props.variant === 'light' ? 'white' : 'black')};
  margin: 0;
  font-weight: 500;
  text-shadow: 0px 1px 5px #271b3a;
  width: 100%;
  @media (max-width: 600px) {
    transform: translateX(0);
    font-size: 28px;
    line-height: 35px;
  }
`

const SectionText = styled.div`
  font-weight: 600;
  font-size: 18px;
  margin: 0;
  font-family: 'TT Norms Pro';
  line-height: 28px;
  color: white;
  border-radius: 20px;
  padding: 20px 20px 20px 20px;
  color: rgb(255 255 255);
  text-shadow: 0px 1px 2px #372958db;
  margin-bottom: 25px;
  margin-top: 35px;
  ${(props) => props.mt && `margin-top: ${props.mt}`};
  @media (max-width: 600px) {
    font-size: 15px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.04em;
  }
`

const HeadlineBold = styled.h2`
  margin: 0;
  font-family: 'TT Norms Pro';
  font-style: normal;
  font-size: 42px;
  line-height: 54px;
  color: ${(props) => (props.variant === 'light' ? 'white' : 'black')};
  width: 100%;
  font-weight: 700;
  text-shadow: 0px 1px 10px #271b3a99;
  transform: translateX(25px);
  @media (max-width: 600px) {
    transform: translateX(0);
    font-size: 28px;
    line-height: 35px;
  }
  > strong {
    font-family: 'TT Norms Pro Bold';
  }
`

const ContentWrapper = styled.div`
  width: 450px;
  @media (max-width: 600px) {
    width: auto;
  }
`

const ErrorHeadline = styled.h2`
  font-family: 'TT Norms Pro Bold';
  font-style: normal;
  font-size: 18px;
  color: #fff;
`

const ErrorText = styled.p`
  font-family: 'TT Norms Pro Bold';
  font-style: normal;
  font-size: 16px;
  color: #fff;
`

function Footer(props) {
  const { variant } = props
  const { t } = useTranslation('')
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const code = params.get('code')
  const message = params.get('message')

  let content
  if (code === 'ok') {
    content = (
      <>
        <h1>{t('contactSuccess.title')}</h1>
        <a href="/">{t('contactSuccess.text')}</a>
      </>
    )
  } else if (code === 'no_email' || code === 'no_body') {
    content = (
      <>
        <Headline variant={variant}>{t('contactFooter.title')[0]}</Headline>
        <HeadlineBold variant={variant}>
          <strong>{t('contactFooter.title')[1]}</strong>
        </HeadlineBold>
        <ErrorHeadline>{'There was a problem with your submission.'}</ErrorHeadline>
        <ErrorText>{message || t('contactError.defaultMessage')}</ErrorText>
        <ContactForm variant={variant} />
      </>
    )
  } else {
    content = (
      <>
        <Headline variant={variant}>{t('contactFooter.title')[0]}</Headline>
        <HeadlineBold variant={variant}>
          <strong>{t('contactFooter.title')[1]}</strong>
        </HeadlineBold>
        <SectionText variant={variant}>{t('contactFooter.text')}</SectionText>
        <ContactForm variant={variant} />
      </>
    )
  }

  return (
    <FooterWrapper>
      <ContentWrapper>{content}</ContentWrapper>
    </FooterWrapper>
  )
}
export default Footer
